// ClearButton.js
// ClearButton.js
import React, { Component } from 'react';

class ClearButton extends Component {
    render() {
        const { onClick, style } = this.props;
        return (
            <button
                type="button"
                className="clear-amc-btn"
                style={{
                    position: "absolute",
                    top: "0",
                    transform: "translateY(-50%)",
                    right: "15px",
                    color: "black",
                    fontWeight: "500",
                    padding: "5px 10px",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "4px",
                    fontSize: "1rem",
                    backgroundColor: "#fff",
                    border: "1px solid #DDDDDD",
                    zIndex: 0,
                    ...style
                }}
                onClick={onClick}
            >
                Clear All
            </button>
        );
    }
}

export default ClearButton;
